import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import TextareaAutoSize from 'react-textarea-autosize';
import classnames from 'classnames';
import { isEmpty } from '../../helpers';
var css = {
  "label": "rui-gzorv",
  "astrix": "rui-skVLo",
  "input": "rui-ouy1c",
  "whiteBg": "rui-U4NYJ",
  "errorText": "rui-xnC9F",
  "error": "rui-fkAsf",
  "disabled": "rui-Fak28",
  "hintContainer": "rui-6rw1t",
  "text": "rui-i7yP7",
  "lengthCounter": "rui-BIms0",
  "errorIcon": "rui-h8KGD"
};
import Icon from '../Icon/Icon';
var NewTextarea = function NewTextarea(_ref) {
  var _classnames;
  var value = _ref.value,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    minRows = _ref.minRows,
    maxRows = _ref.maxRows,
    maxLength = _ref.maxLength,
    label = _ref.label,
    id = _ref.id,
    name = _ref.name,
    dataAutId = _ref.dataAutId,
    labelDataAutId = _ref.labelDataAutId,
    errorAutId = _ref.errorAutId,
    errorText = _ref.errorText,
    placeholder = _ref.placeholder,
    isRequired = _ref.isRequired,
    isDisabled = _ref.isDisabled,
    _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? {} : _ref$classes,
    isWhiteBg = _ref.isWhiteBg,
    hintText = _ref.hintText,
    hideMaxLength = _ref.hideMaxLength,
    hintTextClass = _ref.hintTextClass,
    showErrorIcon = _ref.showErrorIcon;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, css.container, (_classnames = {}, _defineProperty(_classnames, css.error, !isEmpty(errorText)), _defineProperty(_classnames, css.disabled, isDisabled), _defineProperty(_classnames, classes.error, !isEmpty(errorText)), _defineProperty(_classnames, classes.disabled, isDisabled), _classnames))
  }, /*#__PURE__*/React.createElement("label", {
    className: classnames(classes.label, css.label),
    htmlFor: id,
    "data-aut-id": labelDataAutId
  }, label, isRequired && /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.astrix, css.astrix),
    "data-aut-id": "astrix"
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.inputContainer, css.inputContainer)
  }, /*#__PURE__*/React.createElement(TextareaAutoSize, {
    minRows: minRows,
    maxRows: maxRows,
    autoComplete: "off",
    maxLength: maxLength,
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    id: id,
    name: name,
    "data-aut-id": dataAutId,
    className: classnames(classes.input, css.input, _defineProperty({}, css.whiteBg, isWhiteBg)),
    required: isRequired,
    disabled: isDisabled
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(css.hintContainer, hintTextClass, _defineProperty({}, css.error, errorText))
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(css.text, _defineProperty({}, classes.errorText, errorText)),
    "data-aut-id": errorAutId
  }, showErrorIcon && errorText && /*#__PURE__*/React.createElement(Icon, {
    icon: 'attentionHaired',
    color: "error",
    iconClass: css.errorIcon,
    size: 16
  }), errorText || hintText), !hideMaxLength && maxLength && /*#__PURE__*/React.createElement("span", {
    className: classnames(css.lengthCounter)
  }, "".concat(value === null || value === void 0 ? void 0 : value.length, " / ").concat(maxLength))));
};
NewTextarea.defaultProps = {
  value: '',
  minRows: 4,
  maxRows: 10,
  maxLength: 500,
  label: 'Description',
  id: 'textarea',
  name: 'textarea',
  dataAutId: 'textarea',
  labelDataAutId: 'textarea-label',
  errorAutId: 'textarea-error',
  errorText: '',
  placeholder: 'Type Here...',
  isRequired: false,
  classes: {},
  isDisabled: false,
  isWhiteBg: false,
  hintText: '',
  hideMaxLength: true,
  showErrorIcon: false
};
export default NewTextarea;